import React, { useId } from 'react';
import type { IntakeFormField } from '../../api/bookingApi';
import type { BirthdayParts } from './birthday';

interface BirthdayFieldProps {
  field: Pick<IntakeFormField, 'label' | 'required'>;
  parts: BirthdayParts;
  onPartChange: (part: keyof BirthdayParts, value: string) => void;
  inputId?: string;
  errorId?: string;
  disabled?: boolean;
  disableAutofill?: boolean;
  className: string;
}

export default function BirthdayField({ field, parts, onPartChange, inputId, errorId, disabled = false, disableAutofill = false, className }: BirthdayFieldProps) {
  const generatedId = useId();
  const id = inputId ?? `birthday-${generatedId}`;
  return (
    <fieldset className="min-w-0" aria-describedby={errorId} aria-invalid={errorId ? true : undefined}>
      <legend className="block w-full max-w-full text-sm font-semibold text-gray-700 mb-1.5 break-words">
        {field.label}
        {field.required && <span className="text-primary-deep ml-1">*</span>}
      </legend>
      <div className="flex gap-3">
        {(['month', 'day', 'year'] as const).map((part) => (
          <div key={part} className={part === 'year' ? 'w-28 min-w-0' : 'w-24 min-w-0'}>
            <label htmlFor={`${id}-${part}`} className="block text-sm text-gray-700 mb-1.5">
              {part === 'month' ? 'Month' : part === 'day' ? 'Day' : 'Year'}
            </label>
            <input
              id={`${id}-${part}`}
              type="text"
              disabled={disabled}
              inputMode="numeric"
              autoComplete={disableAutofill ? 'off' : `bday-${part}`}
              className={className}
              value={parts[part]}
              onChange={(event) => onPartChange(part, event.target.value)}
              aria-describedby={errorId}
              aria-invalid={errorId ? true : undefined}
            />
          </div>
        ))}
      </div>
    </fieldset>
  );
}
